import * as React from 'react';
import t from "../../Utils/Translation";
import Accordion from 'react-bootstrap/Accordion';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Tooltip from '@mui/material/Tooltip';

export default function NotificationItem(props) {
    const notificationId = props.notificationId; 
    const title = props.title;
    const content = props.content;
    const createdOn = props.createdOn;
    const timeSince = props.timeSince;
    const markNotificationAsRead = props.markNotificationAsRead;

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
      <Row>
        <Accordion defaultActiveKey="999">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <Container>
                <Row>
                  <Col xs={8}>
                  <span className="lykiocss-notification-title">{`${title}`}</span>
                  </Col>
                  <Col>
                  <span className="lykiocss-notification-date">{`${timeSince}`}</span>
                  </Col>
                </Row>
              </Container>
            </Accordion.Header>
            <div className='lykiocss-notification-accordion-body'>
            <Accordion.Body>
              <p>{content}</p>
              
              <Tooltip title="delete this notification">
              <span className="lykioccs-notificationslist-hover float-end" title={t('Mark as read and remove')} 
                onClick={() => {
                    markNotificationAsRead(notificationId);
                    handleClick();
                    }}>
                    <i className="bi bi-archive"></i>
              </span>
              </Tooltip>
              <span className='lykiocss-notification-date float-end'>{createdOn}</span>

            </Accordion.Body>
            </div>
          </Accordion.Item>
        </Accordion>
      </Row>
  );
}


